import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 3v4a1 1 0 0 0 1 1h4","key":"svg-0"}],["path",{"d":"M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2","key":"svg-1"}],["path",{"d":"M9 14v.01","key":"svg-2"}],["path",{"d":"M12 14v.01","key":"svg-3"}],["path",{"d":"M15 14v.01","key":"svg-4"}]]

const IconFileDots = createReactComponent('outline', 'file-dots', 'FileDots', __iconNode);

export default IconFileDots;